<div *ngIf="mfaState === 'setup'">
  <div class="mfa-code-container">
    <span translate>SECURE_MFA_MESSAGE</span>

    <div>
      <span class="small" translate>RECOMMENDED_APPS</span>:
      <ul class="small">
        <li>Windows: <a href="https://www.microsoft.com/en-us/security/mobile-authenticator-app" target="_blank">Microsoft Authenticator</a></li>
        <li>Cross-platform: <a href="https://support.google.com/accounts/answer/1066447" target="_blank">Google Authenticator</a></li>
      </ul>
    </div>

    <div class="my-4">
      <img *ngIf="qrCodeImage" [src]="qrCodeImage" alt="QR Code" class="mfa-code-img" />
    </div>

    <span translate>SETUP_WITH_APP_ON_THIS_MACHINE</span>

    <span class="mt-3" translate>SECURE_MFA_INSTRUCTIONS</span>

    <div class="mt-3">
      <div class="setup-code-form" [formGroup]="form">
        <div class="form-group">
          <lib-gung-text-input
            gungTranslate="DEVICE_NAME"
            formControlName="deviceName"
            placeholder="{{ 'e.g. Work iPhone' | translate }}"
          ></lib-gung-text-input>
          <lib-forms-message-error [controller]="form.get('deviceName')"></lib-forms-message-error>
        </div>

        <div class="form-group">
          <lib-gung-text-input
            gungTranslate="VERIFY_CODE"
            formControlName="code"
            placeholder="{{ 'Enter 6-digit code' | translate }}"
            maxlength="6"
          ></lib-gung-text-input>
          <lib-forms-message-error [controller]="form.get('code')"></lib-forms-message-error>
        </div>
      </div>

      <div class="d-flex verify-button">
        <button (click)="submitSetup()" class="btn btn-primary" translate>VERIFY</button>
      </div>
    </div>

    <div *ngIf="invalidSetupCode" class="alert alert-danger mt-2" translate>INVALIDE_MFA_CODE</div>

    <p class="small mt-3" translate>SECURE_MFA_NOTE</p>
  </div>
</div>

<div *ngIf="mfaState === 'code'">
  <div class="mfa-code-container form-group">
    <label class="mfa-label" for="mfa-input" translate>ENTER_MFA_CODE</label>
    <input [(ngModel)]="code" id="mfa-input" maxlength="6" class="mfa-input form-control" (keydown.enter)="submit()" autofocus />
  </div>
  <div *ngIf="invalidMfaCode" class="alert alert-danger mt-2" translate>INVALIDE_MFA_CODE</div>

  <div class="d-flex mt-3 justify-content-between">
    <button (click)="cancel()" class="btn btn-warning" translate>CANCEL</button>
    <button (click)="submit()" class="btn btn-primary" translate>LOGIN</button>
  </div>
</div>
